(() => {
  // ---------------------------------------------------------------------
  // PayPal Smart Buttons controller
  // Reads window.PayPalConfig (set in layout/theme.liquid) for the
  // checkout currency and the store-currency -> checkout-currency rate.
  //
  // IMPORTANT: PayPal Checkout does not settle in every currency.
  // If your Shopify store currency is not on PayPal's supported list
  // (paypal.com/us/webapps/mpp/country-worldwide) you MUST checkout in a
  // supported currency (this theme defaults to USD) and convert the
  // amount client-side using PayPalConfig.exchangeRateToUSD.
  // Update that rate regularly, or replace this with a live-rate call.
  // ---------------------------------------------------------------------
  const config = window.PayPalConfig || {};
  const currency = config.currency || 'USD';
  const exchangeRate = Number(config.exchangeRateToUSD || 1);

  const toCheckoutAmount = amountCents => (
    (Number(amountCents || 0) / 100) * exchangeRate
  ).toFixed(2);

  const renderButtons = (containerId, amountCents) => {
    const container = document.getElementById(containerId);
    if (!container) return;
    if (typeof paypal === 'undefined' || !paypal.Buttons) {
      container.innerHTML = '<p class="paypal-error">PayPal is unavailable right now.</p>';
      return;
    }
    if (!amountCents || Number(amountCents) <= 0) {
      container.innerHTML = '';
      delete container.dataset.paypalRendered;
      return;
    }
    // Skip only if THIS live element already shows buttons for this amount
    // (a fresh element — e.g. after the cart drawer re-renders — always re-renders).
    if (container.dataset.paypalRendered === String(amountCents) && container.childElementCount > 0) return;
    container.dataset.paypalRendered = String(amountCents);

    container.innerHTML = '';
    container.dataset.paypalAmountCents = amountCents;

    paypal.Buttons({
      style: { layout: 'vertical', shape: 'rect', label: 'paypal', responsive: true },
      createOrder(data, actions) {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: toCheckoutAmount(container.dataset.paypalAmountCents),
              currency_code: currency,
            },
          }],
        });
      },
      onApprove(data, actions) {
        return actions.order.capture().then(details => {
          const name = details?.payer?.name?.given_name || '';
          container.innerHTML = `<p class="paypal-success">${document.documentElement.lang === 'ar'
            ? `تم الدفع بنجاح${name ? '، شكراً ' + name : ''}.`
            : `Payment completed${name ? ', thank you ' + name : ''}.`}</p>`;
          document.dispatchEvent(new CustomEvent('paypal:payment-approved', { detail: { details, containerId } }));
        });
      },
      onCancel() {
        // Buttons remain mounted so the shopper can retry.
      },
      onError(err) {
        console.error('PayPal Checkout error:', err);
        container.innerHTML = `<p class="paypal-error">${document.documentElement.lang === 'ar'
          ? 'حدث خطأ أثناء الدفع. يرجى المحاولة مرة أخرى.'
          : 'Something went wrong with payment. Please try again.'}</p>`;
      },
    }).render(`#${containerId}`);
  };

  const initAll = () => {
    document.querySelectorAll('[data-paypal-amount-cents]').forEach(el => {
      renderButtons(el.id, el.dataset.paypalAmountCents);
    });
  };

  window.PayPalCheckout = { renderButtons, initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
